import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireContract } from '~/utils/guards';

/**
 * Layout route: all /enrichments/google/** require an enrolled google-ads contract.
 * Both LIVE and TRIAL_POC are allowed so a trial subsidiary can open and resume
 * its own in-progress Catalog Operations Google batches (which route here); only a
 * missing/unenrolled contract is gated to Product Not Enrolled.
 */
export const Route = createFileRoute('/_authenticated/_tenant/enrichments/google')({
  beforeLoad: requireContract('google', ['LIVE', 'TRIAL_POC']),
  component: () => <Outlet />,
});
